import { FlexTreatment } from 'src/gqlReactTypings.generated.d';
import { useFlexServingsDecision } from './useIsUserInFlexServings';

/**
 * Whether this user gets Flex V3, whose first add of a main is one serving instead of a full meal's
 * worth. Everything else matches Flex V2.
 */
export const useIsFlexServingsV3 = (): boolean => useFlexServingsDecision().flexTreatment === FlexTreatment.FlexV3;
